import React from "react";
import { Minus, Plus } from "lucide-react";

const QuantitySelector = ({ value, onChange, min = 1, max = 99, size = "md" }) => {
  const dec = () => onChange(Math.max(min, value - 1));
  const inc = () => onChange(Math.min(max, value + 1));
  const dim = size === "sm" ? "h-8 w-8" : "h-11 w-11";
  return (
    <div className="inline-flex items-center border border-ink" data-testid="quantity-selector">
      <button
        onClick={dec}
        disabled={value <= min}
        aria-label="Decrease quantity"
        data-testid="qty-decrease"
        className={`${dim} flex items-center justify-center transition-colors hover:bg-ink hover:text-paper disabled:opacity-30 disabled:hover:bg-transparent disabled:hover:text-ink`}
      >
        <Minus size={16} />
      </button>
      <span
        className={`${size === "sm" ? "w-8" : "w-12"} text-center font-mono text-sm`}
        data-testid="qty-value"
      >
        {value}
      </span>
      <button
        onClick={inc}
        disabled={value >= max}
        aria-label="Increase quantity"
        data-testid="qty-increase"
        className={`${dim} flex items-center justify-center transition-colors hover:bg-ink hover:text-paper disabled:opacity-30 disabled:hover:bg-transparent disabled:hover:text-ink`}
      >
        <Plus size={16} />
      </button>
    </div>
  );
};

export default QuantitySelector;
